export default "__VITE_ASSET__ndwcRT1O__"